import { render, staticRenderFns } from "./FormFieldset.vue?vue&type=template&id=3b32d623&scoped=true"
import script from "./FormFieldset.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldset.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormFieldset.vue?vue&type=style&index=0&id=3b32d623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32d623",
  null
  
)

export default component.exports